// extracted by mini-css-extract-plugin
module.exports = {"skillsTitle":"Skills-module--skills-title--2VLn0"};